var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9537 5.24297C21.3427 5.24297 21.6666 5.56596 21.6666 5.97696V6.35696C21.6666 6.75795 21.3427 7.09095 20.9537 7.09095H4.38045C3.99046 7.09095 3.6666 6.75795 3.6666 6.35696V5.97696C3.6666 5.56596 3.99046 5.24297 4.38045 5.24297H7.29616C7.88845 5.24297 8.4039 4.82197 8.53714 4.22798L8.68983 3.54598C8.92713 2.61699 9.70809 2 10.6019 2H14.7313C15.6154 2 16.4051 2.61699 16.6336 3.49699L16.797 4.22698C16.9293 4.82197 17.4447 5.24297 18.038 5.24297H20.9537ZM19.4724 19.134C19.7768 16.2971 20.3098 9.55712 20.3098 9.48913C20.3292 9.28313 20.2621 9.08813 20.1289 8.93113C19.9859 8.78413 19.805 8.69713 19.6057 8.69713H5.73512C5.53477 8.69713 5.34415 8.78413 5.21188 8.93113C5.07767 9.08813 5.01154 9.28313 5.02126 9.48913C5.02305 9.50162 5.04217 9.73903 5.07415 10.1359C5.21618 11.8992 5.61176 16.8102 5.86738 19.134C6.04828 20.846 7.17158 21.922 8.79866 21.961C10.0542 21.99 11.3477 22 12.6704 22C13.9162 22 15.1815 21.99 16.476 21.961C18.1595 21.932 19.2818 20.875 19.4724 19.134Z",
    fill: "#FF0909"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBold);
export default __webpack_public_path__ + "static/media/delete-bold.c5b353939f23c66b6f2d2d5e3a05b284.svg";
export { ForwardRef as ReactComponent };